import moment from 'moment';

angular.module('am4')
.factory('machineService', function($http, $q, $translate, appCacheService, apiUrl, config) {

    function isMachineErrorFresh(error_date) {
        if (error_date && moment.utc().diff(moment.utc(error_date), 'hours') >= config.equipmentErrorFreshnessCutoff) {
            return false;
        }
        return true;
    }

    return {
        getMachineData: function() {
            var dataStore = appCacheService.getAppCache('dataStore');
            // if we're after timestamp or there's nothing in machine array
            if (moment().isAfter(dataStore.invalidateAfter) || (dataStore.machineData.machines.length === 0 || dataStore.machineData.machines === undefined)) {
                return $http.get(apiUrl + '/machines')
                .then(function(response) {
                    var machines = response.data && response.data.machines || [];
                    machines = machines.map(function(machine) {
                        machine.nickname = machine.nickname || '';
                        machine.search = [
                            machine.frame_serial,
                            machine.console_serial,
                            machine.nickname,
                            machine.machine_type_code ? $translate.instant(machine.machine_type_code.toUpperCase()) : '',
                            machine.series,
                            machine.facility_id
                        ].join('');

                        if (machine.error_code !== 0 && !isMachineErrorFresh(machine.error_date)) {
                            machine.error_code = 0;
                        }

                        return machine;
                    });

                    // set information in dataStore
                    dataStore.invalidateAfter = moment().add(1, 'hour');
                    dataStore.machineData = {
                        machines: machines
                    };

                    appCacheService.setAppCache('dataStore', dataStore);
                    // return data to controller
                    return {
                        machines: dataStore.machineData.machines
                    };
                });
            }
            // if data still usable, return promise containing data to controller
            return $q.when({
                machines: dataStore.machineData.machines
            });

        },
        getMachineDetail: function(frame_serial) {
            return $http({
                method: 'GET',
                url: apiUrl + '/machines/' + frame_serial,
                params: {
                    language: $translate.use() || 'en'
                }
            })
            .then(function(res) {
                // This is the monkey patch for AMF-763, AMF-619
                if (res.data === null) {
                    throw new Error('Not found');
                } else if (res.data.error_code !== 0 && !isMachineErrorFresh(res.data.error_date)) {
                    res.data.error_code = 0;
                }

                return res;
            });
        },
        getMachineSnapshots: function(frame_serial) {
            return $http.get(apiUrl + '/machines/' + frame_serial + '/history')
            .then(function(res) {
                return res;
            });
        },
        getMachineWorkouts: function(frame_serial, range, offset) {
            var config = {};
            if (range) {
                config.params = {
                    range: range,
                    offset: offset
                };
            }

            return $http.get(apiUrl + '/machines/' + frame_serial + '/workouts', config)
            .then(function(res) {
                return res.data;
            });
        },
        setMachineActiveState: function(frame_serial, setting) {
            return $http.put(apiUrl + '/machines/' + frame_serial + '/active', {
                is_active: setting
            })
            .then(function() {
                appCacheService.updateCachedMachine(frame_serial, 'is_active', setting);
                return { is_active: setting };
            });
        },
        setMachineRemovedState: function(frame_serial, setting) {
            return $http.put(apiUrl + '/machines/' + frame_serial + '/removed', {
                is_removed: setting
            })
            .then(function(res) {
                appCacheService.updateCachedMachine(frame_serial, 'is_removed', setting);
                return res.data;
            });
        },
        setMachineNickname: function(frame_serial, name) {
            return $http.put(apiUrl + '/machines/' + frame_serial + '/nickname', {
                nickname: name
            })
            .then(function(res) {
                appCacheService.updateCachedMachine(frame_serial, 'nickname', name);
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/machine.js